import Navbar from './Navbar'
import Footer from './Footer'
import { BUSINESS } from '../../constants/business'

/**
 * Layout component wrapping all pages with Navbar and Footer.
 * Includes skip-to-content link for accessibility.
 */
export default function Layout({ children }) {
  return (
    <>
      {/* Skip to main content — accessibility */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>

      <Navbar />

      <main
        id="main-content"
        role="main"
        tabIndex={-1}
        className="outline-none pt-16"
      >
        {children}
      </main>

      {/* Mobile floating Call Now pill */}
      <a
        href={`tel:${BUSINESS.phone}`}
        className="fixed bottom-5 right-4 z-40 lg:hidden flex items-center gap-2 bg-brand-red text-white rounded-full shadow-xl px-4 h-12 btn-phone-pulse hover:bg-[#c1121f] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-red"
        aria-label={`Call us now at ${BUSINESS.phoneFormatted}`}
      >
        <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.86 13a19.79 19.79 0 01-3.07-8.67A2 2 0 012.77 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 9.91a16 16 0 006.16 6.16l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
        </svg>
        <span className="font-heading font-bold text-sm tracking-wide">Call Now</span>
      </a>

      <Footer />
    </>
  )
}
